import Http from "../../http/client";

export default async (userId, payload) => {
  const response = await Http.post('admin/users/'+userId+'/permissions', payload);
  return response.data;
}
